<template>
  <q-page class="container" padding>
    <div class="row justify-between">
      <p class="text-h6 text-brand-5 text-weight-bold">Configurar Tema</p>
      <q-select
        class="col-2"
        outlined
        dense
        v-model="cliente"
        :options="listaClientes"
        label="Clientes"
        :option-label="
          (opt) =>
            Object(opt) === opt && 'clienteId' in opt ? opt.clienteId : ''
        "
      />
    </div>

    <main
      v-if="cliente"
      class="row justify-around text-brand-5 text-weight-bold"
    >
      <div class="col-2">
        Header
        <q-icon
          name="info"
          size="18px"
          style="cursor: pointer"
          @click="headerModal = true"
        />
        <q-color v-model="cor1" class="my-picker" />
      </div>
      <div class="col-2">
        Sub Header
        <q-icon
          name="info"
          size="18px"
          style="cursor: pointer"
          @click="subHeaderModal = true"
        />
        <q-color v-model="cor2" class="my-picker" />
      </div>
      <div class="col-2">
        Indicativo de Página
        <q-icon
          name="info"
          size="18px"
          style="cursor: pointer"
          @click="indicativoPaginaModal = true"
        />
        <q-color v-model="cor3" class="my-picker" />
      </div>
      <div class="col-2">
        Texto Sub Header
        <q-icon
          name="info"
          size="18px"
          style="cursor: pointer"
          @click="textoSubHeaderModal = true"
        />
        <q-color v-model="cor4" class="my-picker" />
      </div>
      <div class="col-2">
        Texto Header
        <q-icon
          name="info"
          size="18px"
          style="cursor: pointer"
          @click="textoHeaderModal = true"
        />
        <q-color v-model="cor5" class="my-picker" />
      </div>
    </main>
    <div v-if="cliente">
      <q-btn
        class="full-width q-mt-lg"
        color="primary"
        label="Enviar Cores"
        no-caps
        icon="check_circle_outline"
        @click="enviar"
      />
    </div>
    <div v-if="cliente">
      <q-btn
        class="full-width q-mt-lg"
        color="red"
        label="Excluir Tema"
        no-caps
        icon="delete"
        @click="confirm"
      />
    </div>
    <p v-if="cliente" class="text-h6 q-mt-lg text-brand-5 text-weight-bold">
      Configurar Logo
    </p>

    <div v-if="cliente" class="row border q-mr-xl mobile2">
      <q-file
        dense
        outlined
        v-model="img"
        class="col-md-3"
        type="file"
        label="Adicionar Logo"
      />

      <q-btn
        class="col-3 q-ml-md"
        color="positive"
        label="Enviar Logo"
        no-caps
        icon="check_circle_outline"
        @click="enviarLogo"
      />
    </div>

    <div v-if="cliente" class="row border q-mt-md q-mr-xl mobile2">
      <q-file
        dense
        outlined
        v-model="imgImpre"
        class="col-md-3"
        type="file"
        label="Adicionar Logo de Impressão"
      />

      <q-btn
        class="col-3 q-ml-md"
        color="secondary"
        label="Enviar Logo de Impressão"
        no-caps
        icon="check_circle_outline"
        @click="enviarLogoImpressao"
      />
    </div>

    <div v-if="cliente" style="width: 100%" class="row q-mt-md justify-center">
      <q-img fit="contain" height="300px" :src="logo">
        <div class="absolute-bottom text-subtitle1 text-center">Logo Atual</div>
      </q-img>
    </div>

    <div v-if="cliente" style="width: 100%" class="row q-mt-md justify-center">
      <q-img fit="contain" height="300px" :src="logoImpre">
        <div class="absolute-bottom text-subtitle1 text-center">
          Logo Impresão
        </div>
      </q-img>
    </div>

    <h3 v-if="!cliente">Selecione um cliente</h3>
    <q-dialog v-model="headerModal">
      <q-card class="my-card">
        <div style="max-height: 60vh; width: 500px" class="q-pa-md">
          <q-img src="../../../assets/HeaderExample.png" />
        </div>
        <q-separator />
        <q-card-actions align="right">
          <q-btn v-close-popup flat color="primary" label="Ok" />
        </q-card-actions>
      </q-card>
    </q-dialog>
    <q-dialog v-model="subHeaderModal">
      <q-card class="my-card">
        <div style="max-height: 60vh; width: 500px" class="q-pa-md">
          <q-img src="../../../assets/SubHeaderExample.png" />
        </div>
        <q-separator />
        <q-card-actions align="right">
          <q-btn v-close-popup flat color="primary" label="Ok" />
        </q-card-actions>
      </q-card>
    </q-dialog>
    <q-dialog v-model="indicativoPaginaModal">
      <q-card class="my-card">
        <div style="max-height: 60vh; width: 500px" class="q-pa-md">
          <q-img src="../../../assets/IndicativoPagina.png" />
        </div>
        <q-separator />
        <q-card-actions align="right">
          <q-btn v-close-popup flat color="primary" label="Ok" />
        </q-card-actions>
      </q-card>
    </q-dialog>
    <q-dialog v-model="textoSubHeaderModal">
      <q-card class="my-card">
        <div style="max-height: 60vh; width: 500px" class="q-pa-md">
          <q-img src="../../../assets/TextoSubHeader.png" />
        </div>
        <q-separator />
        <q-card-actions align="right">
          <q-btn v-close-popup flat color="primary" label="Ok" />
        </q-card-actions>
      </q-card>
    </q-dialog>
    <q-dialog v-model="textoHeaderModal">
      <q-card class="my-card">
        <div style="max-height: 60vh; width: 500px" class="q-pa-md">
          <q-img src="../../../assets/TextoHeader.png" />
        </div>
        <q-separator />
        <q-card-actions align="right">
          <q-btn v-close-popup flat color="primary" label="Ok" />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import { ref, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
export default {
  props: ["unidadeId"],
  setup() {
    const cor1 = ref("");
    const cor2 = ref("");
    const cor3 = ref("");
    const cor4 = ref("");
    const cor5 = ref("");
    const $q = useQuasar();
    const store = useStore();
    const cliente = ref("");
    const listaClientes = ref([]);
    const img = ref(null);
    const imgImpre = ref(null);
    const logo = ref("");
    const logoImpre = ref("");
    let headerModal = ref(false);
    let subHeaderModal = ref(false);
    let indicativoPaginaModal = ref(false);
    let textoSubHeaderModal = ref(false);
    let textoHeaderModal = ref(false);

    let listarClientes = async () => {
      try {
        let resposta = await store.dispatch("office/listarCliente");

        listaClientes.value = resposta.listaClientes;
      } catch (error) {
        console.error(error);
      }
    };

    watch(
      () => cliente.value,
      () => {
        receber();
      }
    );

    const enviar = async () => {
      try {
        await store.dispatch("office/enviarCores", {
          clienteId: cliente.value.clienteId,
          brand1: cor1.value,
          brand2: cor2.value,
          brand3: cor3.value,
          brand9: cor4.value,
          brand10: cor5.value,
        });
        $q.notify({
          message: "Cores enviados com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        receber();
        location.reload();
      } catch (error) {
        $q.notify({
          message: "Erro ao enviar cores",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(listarClientes);

    const receber = async () => {
      try {
        let resposta = await store.dispatch("office/receberCores", {
          clienteId: cliente.value.clienteId,
        });

        (cor1.value = resposta.data.resultado.dados.tema
          ? resposta.data.resultado.dados.tema.brand1
          : ""),
          (cor2.value = resposta.data.resultado.dados.tema
            ? resposta.data.resultado.dados.tema.brand2
            : ""),
          (cor3.value = resposta.data.resultado.dados.tema
            ? resposta.data.resultado.dados.tema.brand3
            : ""),
          (cor4.value = resposta.data.resultado.dados.tema
            ? resposta.data.resultado.dados.tema.brand9
            : "");
        cor5.value = resposta.data.resultado.dados.tema
          ? resposta.data.resultado.dados.tema.brand10
          : "";
        logo.value = resposta.data.resultado.dados.logos.logo;
        logoImpre.value = resposta.data.resultado.dados.logos.logoImpressao;
      } catch (error) {
        console.log(error);
        $q.notify({
          message: "Erro ao receber cores",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const enviarLogo = async () => {
      if (img.value == null || img.value == "null") {
        $q.notify({
          message: "Selecione alguma Imagem",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }

      try {
        let resposta = await store.dispatch("office/receberUpload", {
          clienteId: cliente.value.clienteId,
        });

        let formAttributes = resposta.data.resultado.dados.formAttributes;
        let formInputs = resposta.data.resultado.dados.formInputs;

        const formData = new FormData();

        for (let input in formInputs) {
          formData.append(input, formInputs[input]);
        }

        formData.append("file", img.value);
        var request = new XMLHttpRequest();
        request.open(formAttributes.method, formAttributes.action);
        await request.send(formData);

        await store.dispatch("office/enviarLogo", {
          clienteId: cliente.value.clienteId,
          logo: `${formAttributes.action}/${formInputs.key}`,
        });

        $q.notify({
          message: "Logo enviado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        receber();
      } catch (error) {
        $q.notify({
          message: "Erro ao enviar logo",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const enviarLogoImpressao = async () => {
      if (imgImpre.value == null || imgImpre.value == "null") {
        $q.notify({
          message: "Selecione alguma Imagem",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }

      try {
        let resposta = await store.dispatch("office/receberUpload", {
          clienteId: cliente.value.clienteId,
        });

        let formAttributes = resposta.data.resultado.dados.formAttributes;
        let formInputs = resposta.data.resultado.dados.formInputs;

        const formData = new FormData();

        for (let input in formInputs) {
          formData.append(input, formInputs[input]);
        }

        formData.append("file", imgImpre.value);
        var request = new XMLHttpRequest();
        request.open(formAttributes.method, formAttributes.action);
        await request.send(formData);

        await store.dispatch("office/enviarLogoImpressao", {
          clienteId: cliente.value.clienteId,
          logoImpressao: `${formAttributes.action}/${formInputs.key}`,
        });

        $q.notify({
          message: "Logo enviado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        receber();
      } catch (error) {
        $q.notify({
          message: "Erro ao enviar logo",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const excluir = async () => {
      try {
        await store.dispatch("office/excluirTema", {
          clienteId: cliente.value.clienteId,
        });
        $q.notify({
          message: "Tema Excluido com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        location.reload();
      } catch (error) {
        $q.notify({
          message: "Erro ao excluir tema",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    function confirm() {
      $q.dialog({
        title: "Excluir Tema",
        message: "Tem certeza que deseja excluir esse tema?",
        cancel: true,
        persistent: true,
      })
        .onOk(() => {
          excluir();
        })
        .onOk(() => {})
        .onCancel(() => {
          // console.log('>>>> Cancel')
        })
        .onDismiss(() => {
          // console.log('I am triggered on both OK and Cancel')
        });
    }

    return {
      cor1,
      cor2,
      cor3,
      cor4,
      cor5,
      confirm,
      enviar,
      receber,
      enviarLogo,
      img,
      logo,
      cliente,
      listarClientes,
      listaClientes,
      imgImpre,
      logoImpre,
      enviarLogoImpressao,
      excluir,
      headerModal,
      subHeaderModal,
      indicativoPaginaModal,
      textoSubHeaderModal,
      textoHeaderModal,
    };
  },
};
</script>

<style lang="sass" scoped>
.my-picker
  max-width: 250px
</style>
